<app-feature-hero
    title="IT Asset Lifecycle Management Solution"
    description="Streamline daily operations with Infraon’s IT asset lifecycle management solution."
    image="/assets/img/feature-pages/infraon-assets/lifecycle/it-asset-lifecycle-header-bg.webp"
    imageAlt="IT Asset Lifecycle Management Solution Hero Image"
></app-feature-hero>

<app-feature-row
    headingLevel="h2"
    heading="What Is IT Asset Lifecycle Management?"
    [paragraphs]="whatIsParagraphs"
    image="/assets/img/feature-pages/infraon-assets/lifecycle/it-asset-lifecycle-feature-img-1.webp"
    imageAlt="hardware asset management"
    imagePosition="right"
></app-feature-row>

<app-feature-row
    headingLevel="h2"
    heading="Infraon’s IT Asset Lifecycle Management Solution"
    [paragraphs]="solutionParagraphs"
    image="/assets/img/feature-pages/infraon-assets/lifecycle/it-asset-lifecycle-feature-img-2.webp"
    imageAlt="Asset performance"
    imageStyle="box-shadow: none"
    imagePosition="left"
></app-feature-row>

<section class="section-spacing container">
    <div
        class="ai-based-itsm depreciation-calculator case-study d-flex align-items-center justify-content-between bg-grey">
        <div>
            <h2 data-aos="fade-up" data-aos-delay="300" class="section-title text-start">
                Asset Depreciation Can Be Hard to <br />
                Figure Out. But We Can Help!
            </h2>
            <p data-aos="fade-up" data-aos-delay="500" class="section-paragraph text-start">
                Elevate your financial planning by accurately measuring asset <br />
                depreciation – ensure well-informed, strategic decisions.
            </p>

            <a routerLink="/free-tools/asset-depreciation-calculator/" class="crmform-button">
                <span style="color: #0d51d9 !important; font-weight: 700">Calculate</span>
                <svg xmlns="http://www.w3.org/2000/svg" width="10" height="16" viewBox="0 0 10 16" fill="none">
                    <path
                        d="M2.34766 0.9375L8.78125 7.65234C8.92188 7.82812 9.02734 8.03906 9.02734 8.25C9.02734 8.46094 8.92188 8.67188 8.78125 8.8125L2.34766 15.5273C2.03125 15.8789 1.46875 15.8789 1.15234 15.5625C0.800781 15.2461 0.800781 14.7188 1.11719 14.3672L7.02344 8.21484L1.11719 2.09766C0.800781 1.78125 0.800781 1.21875 1.15234 0.902344C1.46875 0.585938 2.03125 0.585938 2.34766 0.9375Z"
                        fill="#1A5AD9" />
                </svg>
            </a>
        </div>
    </div>
</section>

<section class="key-features container section-spacing">
    <h2 class="section-title p-lr-60 p-b-60">
        Key Features of Infraon’s <br />
        IT Asset Lifecycle Management
    </h2>

    <div class="row mx-0 feature-box">
        <div class="col-xl-4 col-lg-4 col-md-6 col-sm-12 col-xs-12 p-b-60">
            <div class="feature-wrapper">
                <svg xmlns="http://www.w3.org/2000/svg" width="35" height="28" viewBox="0 0 35 28" fill="none">
                    <path
                        d="M23.7344 7.375L26.25 4.91406L27.4531 6.17188L33.5781 12.2969L34.8359 13.5L33.5781 14.7578L27.4531 20.8828L26.25 22.1406L23.7344 19.625L24.9922 18.4219L29.8594 13.5L24.9922 8.63281L23.7344 7.375ZM8.75 4.91406L11.2109 7.375L9.95312 8.63281L5.08594 13.5L9.95312 18.4219L11.2109 19.625L8.75 22.1406L7.49219 20.8828L1.36719 14.7578L0.109375 13.5L1.36719 12.2969L7.49219 6.17188L8.75 4.91406Z"
                        fill="#084CD4" />
                    <path
                        d="M19.9844 0L23.375 1.03906L22.8281 2.73438L15.8281 25.4844L15.3359 27.125L12 26.1406L12.4922 24.4453L19.4922 1.69531L19.9844 0Z"
                        fill="#A8C1F1" />
                </svg>
                <h3 class="section-title-s text-start mb-0 py-3">
                    IT Asset Requisition
                </h3>
                <p class="section-paragraph-s text-start mb-0">
                    Create PO requisitions, workflow, and approvals using no-code
                    workflows that are also customizable.
                </p>
            </div>
        </div>
        <div class="col-xl-4 col-lg-4 col-md-6 col-sm-12 col-xs-12 p-b-60">
            <div class="feature-wrapper">
                <svg xmlns="http://www.w3.org/2000/svg" width="25" height="30" viewBox="0 0 25 30" fill="none">
                    <path
                        d="M14.4609 28.5156C13.8047 29.1719 12.9297 29.5 12 29.5C11.0703 29.5 10.1406 29.1719 9.48438 28.5156C8.82812 27.8594 8.5 26.9297 8.5 26H12H15.5C15.5 26.9297 15.1172 27.8594 14.4609 28.5156Z"
                        fill="#A8C1F1" />
                    <path
                        d="M12.2871 0C13.2168 0 14.0371 0.820312 14.0371 1.75V2.84375C18.0293 3.60938 21.0371 7.16406 21.0371 11.375V12.4141C21.0371 14.9844 21.9668 17.5 23.6621 19.4141L24.0449 19.8516C24.5371 20.3984 24.6465 21.1094 24.373 21.7656C24.0996 22.3672 23.4434 22.75 22.7871 22.75H1.78711C1.07617 22.75 0.419922 22.3672 0.146484 21.7656C-0.126953 21.1094 -0.0175781 20.3984 0.474609 19.8516L0.857422 19.4141C2.55273 17.5 3.53711 14.9844 3.53711 12.4141V11.375C3.53711 7.16406 6.54492 3.60938 10.5371 2.84375V1.75C10.5371 0.820312 11.3027 0 12.2871 0Z"
                        fill="#084CD4" />
                </svg>
                <h3 class="section-title-s text-start mb-0 py-3">
                    IT Asset Repository
                </h3>
                <p class="section-paragraph-s text-start mb-0">
                    Always know the location of stock, availability, lifecycle status,
                    warranties, and AMCs for IT assets.
                </p>
            </div>
        </div>
        <div class="col-xl-4 col-lg-4 col-md-6 col-sm-12 col-xs-12 p-b-60">
            <div class="feature-wrapper">
                <svg xmlns="http://www.w3.org/2000/svg" width="35" height="28" viewBox="0 0 35 28" fill="none">
                    <path d="M3.5 12.75V23.25H0V12.75H3.5ZM35 12.75V23.25H31.5V12.75H35Z" fill="#A8C1F1" />
                    <path
                        d="M19 0V1.75V5.25H29.5V28H5V5.25H15.5V1.75V0H19ZM14.1875 14C14.1875 12.7969 13.2031 11.8125 12 11.8125C10.7422 11.8125 9.8125 12.7969 9.8125 14C9.8125 15.2578 10.7422 16.1875 12 16.1875C13.2031 16.1875 14.1875 15.2578 14.1875 14ZM22.5 16.1875C23.7031 16.1875 24.6875 15.2578 24.6875 14C24.6875 12.7969 23.7031 11.8125 22.5 11.8125C21.2422 11.8125 20.3125 12.7969 20.3125 14C20.3125 15.2578 21.2422 16.1875 22.5 16.1875Z"
                        fill="#084CD4" />
                    <rect x="10" y="21" width="14" height="2" rx="1" fill="#A8C0F1" />
                </svg>
                <h3 class="section-title-s text-start mb-0 py-3">
                    IT Asset Discovery
                </h3>
                <p class="section-paragraph-s text-start mb-0">
                    Utilize automated discovery (agent-based, agentless, or active
                    directory-based) to monitor asset availability.
                </p>
            </div>
        </div>
        <div class="col-xl-4 col-lg-4 col-md-6 col-sm-12 col-xs-12 p-b-60">
            <div class="feature-wrapper">
                <svg xmlns="http://www.w3.org/2000/svg" width="32" height="21" viewBox="0 0 32 21" fill="none">
                    <path
                        d="M31.75 3.5V7.875C30.2734 7.875 29.125 9.07812 29.125 10.5C29.125 11.9766 30.2734 13.125 31.75 13.125V17.5C31.75 19.4688 30.1641 21 28.25 21H3.75C1.78125 21 0.25 19.4688 0.25 17.5V13.125C1.67188 13.125 2.875 11.9766 2.875 10.5C2.875 9.07812 1.67188 7.875 0.25 7.875V3.5C0.25 1.58594 1.78125 0 3.75 0H28.25C30.1641 0 31.75 1.58594 31.75 3.5Z"
                        fill="#084CD4" />
                    <path
                        d="M7 6.75C7 5.82031 7.76562 5 8.75 5H22.75C23.6797 5 24.5 5.82031 24.5 6.75V13.75C24.5 14.7344 23.6797 15.5 22.75 15.5H8.75C7.76562 15.5 7 14.7344 7 13.75V6.75ZM21.875 7.625H9.625V12.875H21.875V7.625Z"
                        fill="#A8C1F1" />
                </svg>
                <h3 class="section-title-s text-start mb-0 py-3">
                    Integrated Ticketing
                </h3>
                <p class="section-paragraph-s text-start mb-0">
                    Deploy multi-channel support, intelligent self-service choices,
                    and chatbots to unify ITSM.
                </p>
            </div>
        </div>
        <div class="col-xl-4 col-lg-4 col-md-6 col-sm-12 col-xs-12 p-b-60">
            <div class="feature-wrapper">
                <svg xmlns="http://www.w3.org/2000/svg" width="25" height="29" viewBox="0 0 25 29" fill="none">
                    <path
                        d="M12.5 14C8.61719 14 5.5 10.8828 5.5 7C5.5 3.17188 8.61719 0 12.5 0C16.3281 0 19.5 3.17188 19.5 7C19.5 10.8828 16.3281 14 12.5 14Z"
                        fill="#084CD4" />
                    <path d="M24.5 28.875H0L3.5 17.5H21L24.5 28.875Z" fill="#A8C1F1" />
                </svg>
                <h3 class="section-title-s text-start mb-0 py-3">
                    Agent-Based Discovery
                </h3>
                <p class="section-paragraph-s text-start mb-0">
                    Gain detailed insights into your IT assets and guarantee their
                    availability and condition.
                </p>
            </div>
        </div>
        <div class="col-xl-4 col-lg-4 col-md-6 col-sm-12 col-xs-12 p-b-60">
            <div class="feature-wrapper">
                <svg xmlns="http://www.w3.org/2000/svg" width="36" height="40" viewBox="0 0 36 40" fill="none">
                    <path
                        d="M14.4062 23.75H21.5156C29.25 23.75 35.5 30 35.5 37.7344C35.5 38.9844 34.4062 40 33.1562 40H2.76562C1.51562 40 0.5 38.9844 0.5 37.7344C0.5 30 6.67188 23.75 14.4062 23.75Z"
                        fill="#A8C1F1" />
                    <path
                        d="M18 20C12.4531 20 8 15.5469 8 10C8 4.53125 12.4531 0 18 0C23.4688 0 28 4.53125 28 10C28 15.5469 23.4688 20 18 20Z"
                        fill="#084CD4" />
                </svg>
                <h3 class="section-title-s text-start mb-0 py-3">
                    Vendor Management
                </h3>
                <p class="section-paragraph-s text-start mb-0">
                    Track vendor performance for your IT assets and eliminate any
                    contractual oversights.
                </p>
            </div>
        </div>
        <div class="col-xl-4 col-lg-4 col-md-6 col-sm-12 col-xs-12 p-b-60">
            <div class="feature-wrapper">
                <svg xmlns="http://www.w3.org/2000/svg" width="21" height="28" viewBox="0 0 21 28" fill="none">
                    <path d="M0 0H12.25V8.75H21V28H0V0Z" fill="#084CD4" />
                    <path d="M21 7H14V0L21 7Z" fill="#A8C1F1" />
                    <path
                        d="M2 11C2 10.4477 2.44772 10 3 10H6C6.55228 10 7 10.4477 7 11V14C7 14.5523 6.55228 15 6 15H3C2.44772 15 2 14.5523 2 14V11Z"
                        fill="#A8C0F1" />
                    <path
                        d="M2 18C2 17.4477 2.44772 17 3 17H18C18.5523 17 19 17.4477 19 18V24C19 24.5523 18.5523 25 18 25H3C2.44772 25 2 24.5523 2 24V18Z"
                        fill="#A8C0F1" />
                    <path
                        d="M8 11C8 10.4477 8.44772 10 9 10H12C12.5523 10 13 10.4477 13 11V14C13 14.5523 12.5523 15 12 15H9C8.44772 15 8 14.5523 8 14V11Z"
                        fill="#A8C0F1" />
                    <path
                        d="M14 11C14 10.4477 14.4477 10 15 10H18C18.5523 10 19 10.4477 19 11V14C19 14.5523 18.5523 15 18 15H15C14.4477 15 14 14.5523 14 14V11Z"
                        fill="#A8C0F1" />
                </svg>
                <h3 class="section-title-s text-start mb-0 py-3">
                    IT Assets Catalogue
                </h3>
                <p class="section-paragraph-s text-start mb-0">
                    Gain visibility into purchased and assigned assets, stock levels,
                    or purchase orders.
                </p>
            </div>
        </div>
        <div class="col-xl-4 col-lg-4 col-md-6 col-sm-12 col-xs-12 p-b-60">
            <div class="feature-wrapper">
                <svg xmlns="http://www.w3.org/2000/svg" width="29" height="29" viewBox="0 0 29 29" fill="none">
                    <path
                        d="M14.5 0.5C22.2109 0.5 28.5 6.78906 28.5 14.5C28.5 22.2656 22.2109 28.5 14.5 28.5C6.73438 28.5 0.5 22.2656 0.5 14.5C0.5 10.6172 2.08594 7.0625 4.65625 4.54688L5.91406 3.28906L8.375 5.80469L7.11719 7.00781C5.20312 8.92188 4 11.6016 4 14.5C4 20.2969 8.70312 25 14.5 25C20.2969 25 25 20.2969 25 14.5C25 9.30469 21.1719 4.98438 16.25 4.16406V5.75V7.5H12.75V5.75V2.25V0.5H14.5Z"
                        fill="#084CD4" />
                    <path
                        d="M11.7891 9.92969H11.7344L16.1094 14.3047L17.0391 15.2344L15.2344 17.0938L14.3047 16.1641L9.92969 11.7891L9 10.8594L10.8594 9L11.7891 9.92969Z"
                        fill="#A8C1F1" />
                </svg>
                <h3 class="section-title-s text-start mb-0 py-3">
                    IT Assets History Tracking
                </h3>
                <p class="section-paragraph-s text-start mb-0">
                    Keep track of your IT assets based on historical information, such
                    as the date of purchase, status, condition, etc.
                </p>
            </div>
        </div>
        <div class="col-xl-4 col-lg-4 col-md-6 col-sm-12 col-xs-12 p-b-60">
            <div class="feature-wrapper">
                <svg xmlns="http://www.w3.org/2000/svg" width="29" height="29" viewBox="0 0 29 29" fill="none">
                    <path
                        d="M12.75 8.375C12.75 4.05469 16.25 0.5 20.625 0.5C21.6641 0.5 22.6484 0.71875 23.5234 1.10156L18.875 5.75V10.125H23.25L27.8984 5.47656C28.2812 6.35156 28.5 7.33594 28.5 8.375C28.5 11.7656 26.3672 14.6094 23.4141 15.7578L20.9531 13.2969L19.75 12.0391L18.4922 13.2969L18.0547 13.7344L12.75 8.42969V8.375ZM0.5 23.25L9.6875 14.0625L13.6797 18.0547L13.2422 18.5469L11.9844 19.75L13.2422 21.0078L5.75 28.5L0.5 23.25ZM7.99219 22.8125L6.1875 21.0078L4.32812 22.8125L6.1875 24.6719L7.99219 22.8125Z"
                        fill="#084CD4" />
                    <path
                        d="M16.6953 18.5547L9.64062 11.5H6.25L1 4.5L4.5 1L11.5 6.25V9.69531L18.5547 16.6953L20.25 15L29 23.75L23.75 29L15 20.25L16.6953 18.5547Z"
                        fill="#A8C1F1" />
                </svg>
                <h3 class="section-title-s text-start mb-0 py-3">
                    IT Asset Configuration
                </h3>
                <p class="section-paragraph-s text-start mb-0">
                    Use a centralized configuration management database to track asset
                    utilization and targets.
                </p>
            </div>
        </div>
        <div class="col-xl-4 col-lg-4 col-md-6 col-sm-12 col-xs-12 p-b-60">
            <div class="feature-wrapper">
                <svg xmlns="http://www.w3.org/2000/svg" width="33" height="25" viewBox="0 0 33 25" fill="none">
                    <rect x="4" y="3" width="26" height="19" fill="#A8C1F1" />
                    <path
                        d="M32.25 0.25V24.75H0.75V0.25H32.25ZM8.625 5.5H6V19.5H8.625V5.5ZM10.375 5.5V19.5H12.125V5.5H10.375ZM16.5 5.5H13.875V19.5H16.5V5.5ZM20 5.5V19.5H22.625V5.5H20ZM27 5.5H25.25V19.5H27V5.5Z"
                        fill="#084CD4" />
                </svg>
                <h3 class="section-title-s text-start mb-0 py-3">
                    IT Asset Relocation
                </h3>
                <p class="section-paragraph-s text-start mb-0">
                    Use barcode/code support to detect assets that need to be
                    relocated.
                </p>
            </div>
        </div>
        <div class="col-xl-4 col-lg-4 col-md-6 col-sm-12 col-xs-12 p-b-60">
            <div class="feature-wrapper">
                <svg xmlns="http://www.w3.org/2000/svg" width="21" height="28" viewBox="0 0 21 28" fill="none">
                    <path d="M0 0H12.25V8.75H21V28H0V0Z" fill="#084CD4" />
                    <path d="M21 7H14V0L21 7Z" fill="#A8C1F1" />
                    <path
                        d="M3 11.5C3 11.2239 3.22386 11 3.5 11H17.5C17.7761 11 18 11.2239 18 11.5V11.5C18 11.7761 17.7761 12 17.5 12H3.5C3.22386 12 3 11.7761 3 11.5V11.5Z"
                        fill="white" />
                    <path
                        d="M3 17.5C3 17.2239 3.22386 17 3.5 17H17.5C17.7761 17 18 17.2239 18 17.5V17.5C18 17.7761 17.7761 18 17.5 18H3.5C3.22386 18 3 17.7761 3 17.5V17.5Z"
                        fill="white" />
                    <path
                        d="M3 23.5C3 23.2239 3.22386 23 3.5 23H17.5C17.7761 23 18 23.2239 18 23.5V23.5C18 23.7761 17.7761 24 17.5 24H3.5C3.22386 24 3 23.7761 3 23.5V23.5Z"
                        fill="white" />
                </svg>
                <h3 class="section-title-s text-start mb-0 py-3">
                    IT Asset Disposal
                </h3>
                <p class="section-paragraph-s text-start mb-0">
                    Monitor IT assets to determine when to dispose while keeping the
                    necessary records.
                </p>
            </div>
        </div>
        <div class="col-xl-4 col-lg-4 col-md-6 col-sm-12 col-xs-12 p-b-60">
            <div class="feature-wrapper">
                <svg xmlns="http://www.w3.org/2000/svg" width="34" height="30" viewBox="0 0 34 30" fill="none">
                    <rect x="12" y="6" width="10" height="24" fill="#A8C1F1" />
                    <path
                        d="M17.0332 0C17.9638 0 18.828 0.535714 19.2933 1.33929L33.651 25.9821C34.1163 26.8527 34.1163 27.8571 33.651 28.6607C33.1857 29.5313 32.3216 30 31.391 30H2.67546C1.6784 30 0.814272 29.5313 0.348974 28.6607C-0.116325 27.8571 -0.116325 26.8527 0.348974 25.9821L14.7067 1.33929C15.172 0.535714 16.0362 0 17.0332 0ZM17.0332 8.57143C16.1026 8.57143 15.4379 9.30804 15.4379 10.1786V17.6786C15.4379 18.6161 16.1026 19.2857 17.0332 19.2857C17.8974 19.2857 18.6285 18.6161 18.6285 17.6786V10.1786C18.6285 9.30804 17.8974 8.57143 17.0332 8.57143ZM19.1603 23.5714C19.1603 22.433 18.1632 21.4286 17.0332 21.4286C15.8368 21.4286 14.9062 22.433 14.9062 23.5714C14.9062 24.7768 15.8368 25.7143 17.0332 25.7143C18.1632 25.7143 19.1603 24.7768 19.1603 23.5714Z"
                        fill="#084CD4" />
                </svg>
                <h3 class="section-title-s text-start mb-0 py-3">
                    Low Stock Warnings
                </h3>
                <p class="section-paragraph-s text-start mb-0">
                    Receive immediate alerts when there are low stock levels and avoid
                    under-stocking.
                </p>
            </div>
        </div>
    </div>
</section>

<app-feature-row
    headingLevel="h2"
    heading="Other Features of Infraon’s IT Asset Lifecycle Management"
    listStyle="check"
    checkIconSize="lg"
    [listItems]="otherFeaturesItems"
    image="/assets/img/feature-pages/infraon-assets/lifecycle/ham-feature-image-3.webp"
    imageAlt="it asset management software"
    imageStyle="box-shadow: none"
    imagePosition="left"
></app-feature-row>

<section class="section-spacing container">
    <div class="ai-based-itsm ebook d-flex align-items-center justify-content-between primary-bg position-relative">
        <div>
            <small data-aos="fade-up" data-aos-delay="100">EBOOK</small>
            <h2 data-aos="fade-up" data-aos-delay="300" class="section-title text-start">
                Shaping the Future: IT Asset <br />
                Management Trends
            </h2>
            <p data-aos="fade-up" data-aos-delay="500" class="section-paragraph text-start">
                Discover the latest trends in IT asset management and learn how they
                can <br />
                drive your organization's success.
            </p>

            <a [routerLink]="['/resources', 'ebook', 'future-of-itam-2026']" class="crmform-button" >
                <span class="me-1">Download our e-book</span>
                <svg xmlns="http://www.w3.org/2000/svg" width="18" height="19" viewBox="0 0 18 19" fill="none">
                    <path
                        d="M10.125 1.375V9.91797L12.6914 7.35156C13.1133 6.89453 13.8516 6.89453 14.2734 7.35156C14.7305 7.77344 14.7305 8.51172 14.2734 8.93359L9.77344 13.4336C9.35156 13.8906 8.61328 13.8906 8.19141 13.4336L3.69141 8.93359C3.23438 8.51172 3.23438 7.77344 3.69141 7.35156C4.11328 6.89453 4.85156 6.89453 5.27344 7.35156L7.875 9.91797V1.375C7.875 0.777344 8.36719 0.25 9 0.25C9.59766 0.25 10.125 0.777344 10.125 1.375ZM2.25 12.625H5.80078L7.38281 14.2422C8.26172 15.1211 9.70312 15.1211 10.582 14.2422L12.1641 12.625H15.75C16.9805 12.625 18 13.6445 18 14.875V16C18 17.2656 16.9805 18.25 15.75 18.25H2.25C0.984375 18.25 0 17.2656 0 16V14.875C0 13.6445 0.984375 12.625 2.25 12.625ZM15.1875 16.2812C15.6445 16.2812 16.0312 15.9297 16.0312 15.4375C16.0312 14.9805 15.6445 14.5938 15.1875 14.5938C14.6953 14.5938 14.3438 14.9805 14.3438 15.4375C14.3438 15.9297 14.6953 16.2812 15.1875 16.2812Z"
                        fill="#0d51d9" />
                </svg>
            </a>
        </div>
        <img loading="lazy" src="/assets/img/feature-pages/asset-management-ebook.webp"
            class="asset-mmanagement-ebook m-d-none" alt="asset mmanagement ebook" />
    </div>
</section>

<section class="container section-spacing">
    <h2 class="section-title text-center p-b-60">
        Why Choose Infraon’s IT Asset <br />
        Lifecycle Management Solution?
    </h2>

<app-feature-row
    headingLevel="h3"
    heading="Smooth Integration"
    [paragraphs]="smoothIntegrationParagraph"
    image="/assets/img/feature-pages/infraon-assets/lifecycle/it-asset-lifecycle-feature-img-3.webp"
    imageAlt="Software integration"
    imagePosition="right"
></app-feature-row>

<app-feature-row
    headingLevel="h3"
    heading="Tailored Workflows"
    [paragraphs]="tailoredWorkflowsParagraph"
    image="/assets/img/feature-pages/infraon-assets/lifecycle/qr-code-feature-img-2-01.png"
    imageAlt="Device discovery charts"
    imagePosition="left"
></app-feature-row>

<app-feature-row
    headingLevel="h3"
    heading="Cost Optimization"
    [paragraphs]="costOptimizationParagraph"
    image="/assets/img/feature-pages/infraon-assets/lifecycle/fixed-asset-feature-img-2-01.svg"
    imageAlt="Asset Monitoring"
    imagePosition="right"
></app-feature-row>

<app-feature-row
    headingLevel="h3"
    heading="Higher Efficiency"
    [paragraphs]="higherEfficiencyParagraph"
    image="/assets/img/feature-pages/infraon-assets/lifecycle/fixed-asset-feature-img-1-01.webp"
    imageAlt="improved efficiency"
    imagePosition="left"
></app-feature-row>

<app-feature-row
    headingLevel="h3"
    heading="Compliance and Risk Mitigation"
    [paragraphs]="complianceParagraph"
    image="/assets/img/feature-pages/infraon-assets/lifecycle/qr-code-feature-img-2-01.png"
    imageAlt="Device discovery charts"
    imagePosition="right"
></app-feature-row>

<app-feature-row
    headingLevel="h3"
    heading="In-Depth Asset Transparency"
    [paragraphs]="transparencyParagraph"
    image="/assets/img/feature-pages/infraon-assets/lifecycle/fixed-asset-feature-img-1-01.webp"
    imageAlt="improved efficiency"
    imagePosition="left"
></app-feature-row>
</section>

<section class="section-spacing container">
    <div class="ai-based-itsm case-study d-flex align-items-center justify-content-between bg-grey">
        <div>
            <small data-aos="fade-up" data-aos-delay="100">CASE STUDY</small>
            <h2 data-aos="fade-up" data-aos-delay="300" class="section-title text-start">
                See How Infraon Assets Was a Game-Changer for a Top IT Consulting
                Company
            </h2>
            <div class="case-study-pointers">
                <div>
                    <span></span>
                    <span>75% higher asset efficiency</span>
                </div>
                <div>
                    <span></span>
                    <span>50%-75% lowered asset spend</span>
                </div>
                <div>
                    <span></span>
                    <span>75% more asset compliance</span>
                </div>
            </div>

            <a [routerLink]="['/resources', 'case-studies', 'tcs-passport-seva-project']" class="crmform-button">
                <span style="color: #0d51d9 !important; font-weight: 700">Download Case-study</span>
                <svg xmlns="http://www.w3.org/2000/svg" width="18" height="19" viewBox="0 0 18 19" fill="none">
                    <path
                        d="M10.125 1.375V9.91797L12.6914 7.35156C13.1133 6.89453 13.8516 6.89453 14.2734 7.35156C14.7305 7.77344 14.7305 8.51172 14.2734 8.93359L9.77344 13.4336C9.35156 13.8906 8.61328 13.8906 8.19141 13.4336L3.69141 8.93359C3.23438 8.51172 3.23438 7.77344 3.69141 7.35156C4.11328 6.89453 4.85156 6.89453 5.27344 7.35156L7.875 9.91797V1.375C7.875 0.777344 8.36719 0.25 9 0.25C9.59766 0.25 10.125 0.777344 10.125 1.375ZM2.25 12.625H5.80078L7.38281 14.2422C8.26172 15.1211 9.70312 15.1211 10.582 14.2422L12.1641 12.625H15.75C16.9805 12.625 18 13.6445 18 14.875V16C18 17.2656 16.9805 18.25 15.75 18.25H2.25C0.984375 18.25 0 17.2656 0 16V14.875C0 13.6445 0.984375 12.625 2.25 12.625ZM15.1875 16.2812C15.6445 16.2812 16.0312 15.9297 16.0312 15.4375C16.0312 14.9805 15.6445 14.5938 15.1875 14.5938C14.6953 14.5938 14.3438 14.9805 14.3438 15.4375C14.3438 15.9297 14.6953 16.2812 15.1875 16.2812Z"
                        fill="#0d51d9" />
                </svg>
            </a>
        </div>
        <div>
            <img loading="lazy" src="/assets/img/feature-pages/case-study-illustration.webp"
                class="case-study-illustration m-d-none" alt="Case Study Illurtation" />
        </div>
    </div>
</section>

<section class="container section-spacing">
    <div id="gdpr-wrapper">
        <div class="gdpr-section justify-content-center">
            <img src="/assets/img/feature-pages/gdpr.webp" alt="GDPR Logo" class="me-4 w-100">
            <div>
                <h2 class="section-title mb-3">Our Product Suite is GDPR-Compliant</h2>
                <p class="section-paragraph mb-0">We are compliant with the European General Data Protection Regulation
                    (GDPR) – and <br> our SaaS-based product suite is fully committed to protecting the data of our
                    customers <br> as per the recent standards.</p>
            </div>
        </div>
    </div>
</section>

<app-feature-row
    headingLevel="h2"
    heading="Best Practices for IT Asset Lifecycle Management"
    [paragraphs]="bestPracticesParagraph"
    listStyle="check"
    checkIconSize="sm"
    [listItems]="bestPracticesItems"
    image="/assets/img/feature-pages/infraon-assets/lifecycle/it-asset-lifecycle-feature-img-4.webp"
    imageAlt="it asset management software"
    imageStyle="box-shadow: none"
    imagePosition="left"
></app-feature-row>

<app-feature-row
    headingLevel="h2"
    heading="Benefits of IT Asset Lifecycle Management"
    [paragraphs]="benefitsParagraph"
    listStyle="check"
    checkIconSize="sm"
    [listItems]="benefitsItems"
    image="/assets/img/feature-pages/infraon-assets/lifecycle/it-asset-lifecycle-feature-img-5.webp"
    imageAlt="it asset management software"
    imageStyle="box-shadow: none"
    imagePosition="right"
></app-feature-row>

<section class="container section-spacing">
    <h2 class="section-title text-center">Related Content</h2>

    <div class="row mx-0">
        <div class="col-xl-4 col-lg-4 col-md-12 col-sm-12 col-xs-12 p-4">
            <a routerLink="/it-asset-management/features/it-assets-management-solutions">
                <div class="backlink-container bg-white h-100">
                    <p class="section-title-s text-start">IT asset management</p>
                    <p class="section-paragraph-s text-start">
                        Infraon IT Asset Lifecycle Management offers a centralized,
                        low-code platform to optimize your IT asset usage. Make smart
                        purchasing...
                    </p>
                    <p class="primary-color mb-0">Know more</p>
                </div>
            </a>
        </div>
        <div class="col-xl-4 col-lg-4 col-md-12 col-sm-12 col-xs-12 p-4">
            <a routerLink="/it-asset-management/features/software-assets-management-solutions">
                <div class="backlink-container bg-white h-100">
                    <p class="section-title-s text-start">
                        Software asset management
                    </p>
                    <p class="section-paragraph-s text-start">
                        Infraon IT Asset Lifecycle Management offers a centralized,
                        low-code platform to optimize your IT asset usage. Make smart
                        purchasing...
                    </p>
                    <p class="primary-color mb-0">Know more</p>
                </div>
            </a>
        </div>
        <div class="col-xl-4 col-lg-4 col-md-12 col-sm-12 col-xs-12 p-4">
            <a routerLink="/it-asset-management/features/software-license-management">
                <div class="backlink-container bg-white h-100">
                    <p class="section-title-s text-start">
                        Software Licensing management
                    </p>
                    <p class="section-paragraph-s text-start">
                        Infraon Assets helps you manage the lifecycles of fixed assets
                        like PCs, laptops, furniture, storage devices, etc., with a
                        360-degree view...
                    </p>
                    <p class="primary-color mb-0">Know more</p>
                </div>
            </a>
        </div>
    </div>
</section>

<section class="section-spacing bg-grey">
    <div class="container" id="g2-box-wrapper">
        <div class="g2-box justify-content-between">
            <img loading="lazy" src="/assets/img/feature-pages/g2.svg" alt="G2 Logo">
            <p>Already love using our products? Please <br> share your experiences on G2</p>
            <a href="https://www.g2.com/products/infraon-assets/reviews" class="primary-button">Rate us</a>
        </div>
    </div>
</section>